module.exports = __webpack_public_path__ + "static/media/asibloghero.4b4564b4.png";